<template>
  <StandardButton
    v-bind="buttonProps"
    @click="toggleIsMenuShown"
  >
    <template
      v-if="buttonProps.icon"
      #icon
    >
      <slot name="icon" />
    </template>
  </StandardButton>
  <StandardMenu
    ref="menuRef"
    v-bind="menuProps"
    :popup="true"
    :base-z-index="ABOVE_STICKY_HEADER_Z_INDEX"
  >
    <template
      v-if="$slots.start"
      #start
    >
      <slot name="start" />
    </template>
    <template
      v-if="$slots.item"
      #item="slotProps"
    >
      <slot
        name="item"
        v-bind="slotProps"
      />
    </template>
  </StandardMenu>
</template>
<script lang="ts">
export default {
  name: 'StandardButtonWithMenu',
  compatConfig: { MODE: 3 },
  inheritAttrs: false,
};
</script>
<script setup lang="ts">
import { ref } from 'vue';
import StandardMenu, { StandardMenuProps } from './StandardMenu.vue';
import { ABOVE_STICKY_HEADER_Z_INDEX } from '@/constants/ComponentZIndices';
import type { StandardButtonProps } from '@/types/StandardButtonTypes';

defineProps<{
  buttonProps: StandardButtonProps;
  menuProps: StandardMenuProps;
}>();

const menuRef = ref<InstanceType<typeof StandardMenu> | null>(null);
const toggleIsMenuShown = (e: MouseEvent) => {
  menuRef.value?.toggle(e);
};
</script>
